import styled from 'styled-components';

export default styled.div`
  color: red;
  font-weight: bold;
  margin-bottom: 1rem;
`;
